.registerDocument {
  display: flex;
  flex-direction: column;
  width: 45%;
}

@media (max-width: 767.98px) {
  .registerDocument {
    width: 100%;
  }
}
